import React from 'react'
import { MenuItem } from 'app/common/layout/menu'
import type { Element } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

type Props = {
    breadcrumbKey: string,
    titleKey: string,
    descriptionKey: string,
    children: Element<any>,
    icon?: Element<any>,
    dataLoaded: boolean
}

const BlazonsLayoutComponent = (props: Props) => {
    const {
        breadcrumbKey,
        titleKey,
        descriptionKey,
        children,
        icon,
        dataLoaded
    } = props
    const intl = useIntl()

    const routeDashboard = intl.formatMessage({
        id: 'routes.kingdom.dashboard'
    })
    const breadcrumb = [
        {
            link: routeDashboard,
            title: intl.formatMessage({
                id: 'kingdom.dashboard.title.breadcrumb.end'
            })
        },
        {
            title: intl.formatMessage({
                id: breadcrumbKey
            })
        }
    ]

    return (
        <MenuItem
            breadcrumb={breadcrumb}
            url={routeDashboard}
            title={intl.formatMessage({ id: titleKey })}
            description={intl.formatMessage({
                id: descriptionKey
            })}
            icon={icon}>
            {dataLoaded && <Blazons>{children}</Blazons>}
        </MenuItem>
    )
}

const Blazons = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
`

const BlazonsLayout = BlazonsLayoutComponent

export { BlazonsLayout }
